/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Serializer for answer object related to pitch question object. Serializes fields from Answer model and additionally adds name field with answering user full name
 */
export interface Answer {
  readonly id: string;
  readonly text: string;
  readonly user: string;
  readonly name: string;
  readonly question: string;
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
}
